import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router";

import CoolPage from "../components/CoolPage"

import "./LaundryInfo.less"

// #TODO me faltan las imágenes de esta página
// #TODO qué pasa al pedir una plancha

const LaundryInfo = ({ gotoLaundry }) => (
  <CoolPage
    containerProps={{ className: "tepa laundryInfo" }}
    title="洗衣服务"
    barColor={[255, 255, 255]}
    className="tepaPage tepaLaundry"
    fixedBar
  >
    <section className="bullet">
      {/* <img className="bi" src="http://placekitten.com/300/200" /> */}
      <img src="/static/img/nh/bullet-iron.jpg" />
      <div className="right">
        <p>我需要递送熨斗服务</p>
        <a onClick={() => alert("DISABLED")}>{"预定 >"}</a>
      </div>
    </section>
    <section className="bullet">
      <img src="/static/img/nh/bullet-laundry.jpg" />
      <div className="right">
        <p>周日及节假日不提供洗衣熨烫及去除污渍服务</p>
        <a onClick={gotoLaundry}>{"选择项目 >"}</a>
      </div>
    </section>
    <section>
      <h1>指示</h1>
      <p>通过此应用，您不需要填写送洗衣物的信息表格，您可以100％在线完成您需要的服务</p>
      <div className="twinPics">
        <div>
          <img src="/static/img/nh/app.svg" />
          <p>选择衣服</p>
        </div>
        <div>
          <img src="/static/img/nh/bag.svg" />
          <p>放在篮子里</p>
        </div>
      </div>
    </section>
    <section>
      <h1>工作时间</h1>
      <p>上午10:00前送洗的衣物，可在当日送回，不加收额外费用。上午10:00后送洗的衣物，可在次日送回。</p>
    </section>
    <section>
      <h1>快速服务</h1>
      <p>上午10:00后送洗的衣物，如需在当日14:00之前取回，需支付50%附加费用。</p>
    </section>
  </CoolPage>
)

function mapStateToProps(_state, _ownProps) {
  return {}
}

function mapDispatchToProps(dispatch, _ownProps) {
  return {
    gotoLaundry: () => dispatch(push("/catalogo/tepa/laundry"))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LaundryInfo)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/LaundryInfo.jsx